import makeStyles from '@material-ui/core/styles/makeStyles';

const styles = makeStyles(() => ({
  periodDays: {
    display: 'flex',
    justifyContent: 'center',
    margin: '0.75rem 0',
    fontWeight: 'bold',
    fontSize: 28,
  },
  alert: {
    margin: '1rem 0',
    fontSize: 14,
  },
  success: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& > img': {
      marginBottom: 24,
    },
  },
}));

export default styles;
